import styled from "styled-components";

export const ReportWrapper = styled.span`
  .modal-body {
    padding: 10px 10px;
  }
`

export const ReportManagerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 16px;
`;